import { HttpService, Repository, RepositoryBase, RepositorySaveResponse, TaggedUrl, Tags, Weaver } from '@skylab-shared/core';
import { BankAccountModel } from '@skylab-shared/dataModel';
import { pickBy, ResponseUtils } from '@skylab-shared/utils';
import { FlagChangeResponse } from '../common/flag-change-response';
import { BankAccountBO } from './bank-account.bo';

@Repository({
    boType: BankAccountBO,
    apiController: TaggedUrl.join('myCompany/bankAccounts', [Tags.Api])
})
export class BankAccountRepositoryBase extends RepositoryBase<BankAccountBO, BankAccountModel> {
    public constructor(
        private readonly http: HttpService,
        private readonly weaver: Weaver) {
        super(http);
    }

    protected createBO(): BankAccountBO {
        return new BankAccountBO(this.weaver);
    }

    protected async preparePlainObjectAsync(model: BankAccountModel): Promise<any> {
        return {
            id: model.id,
            version: model.version,

            default: model.default,
            name: model.name,
            bankName: model.bankName,
            swift: model.swift,
            number: model.number,
            currencyId: model.currencyId
        };
    }

    protected async fromPlainObjectAsync(item: any): Promise<BankAccountModel> {
        return new BankAccountModel(pickBy({
            id: item.id,
            sun: item.sun,
            version: item.version,

            default: item.default,
            name: item.name,
            bankName: item.bankName,
            swift: item.swift,
            number: item.number,
            companyId: item.companyId,
            currencyId: item.currencyId
        }, val => val !== void 0));
    }

    //#region default
    public async setAsDefaultAsync(currency: string, id: number): Promise<FlagChangeResponse | undefined> {
        try {
            const response = await this.http.sendRequest({
                method: 'PUT',
                url: `[api] myCompany/bankAccounts/${currency}/default`,
                params: { id: id }
            });
            if (ResponseUtils.isStatusSuccess(response.status)) {
                const successData: RepositorySaveResponse = response.data;
                return {
                    value: true,
                    id: successData.object?.id,
                    version: successData.object?.version
                };
            }
        } catch (err) {
            this.logger.error(err);
        }

        return undefined;
    }

    public async setAsNotDefaultAsync(currency: string, id: number): Promise<FlagChangeResponse | undefined> {
        try {
            const response = await this.http.sendRequest({
                method: 'DELETE',
                url: `[api] myCompany/bankAccounts/${currency}/default`,
                params: { id: id }
            });
            if (ResponseUtils.isStatusSuccess(response.status)) {
                const successData: RepositorySaveResponse = response.data;
                return {
                    value: false,
                    id: successData.object?.id,
                    version: successData.object?.version
                };
            }
        } catch (err) {
            this.logger.error(err);
        }

        return undefined;
    }
    //#endregion
}
